/** During the tenant migration, legacy certification applies only when the claim is absent. */
export function isRMCertified(
    claims: { kfh_rm_certified?: unknown } | undefined,
    rm?: { certified?: boolean },
): boolean {
    if (claims?.kfh_rm_certified !== undefined) return claims.kfh_rm_certified === true;
    return rm?.certified === true;
}
